module.exports = __webpack_public_path__ + "img/getting-on-track.5f3db385.png";